// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.securearea

import org.multipaz.cbor.DataItem
import org.multipaz.securearea.PassphraseConstraints
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.toDataItem

fun PassphraseConstraints.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "uvM3E3bDjLlMMDv9rQeipnZxlfnqpkbh401zi6v-nAk")
val PassphraseConstraints_cborSchemaId = ByteString(-70, -13, 55, 19, 118, -61, -116, -71, 76, 48, 59, -3, -83, 7, -94, -90, 118, 113, -107, -7, -22, -90, 70, -31, -29, 77, 115, -117, -85, -2, -100, 9)

fun PassphraseConstraints.Companion.fromCbor(data: ByteArray): PassphraseConstraints {
    return PassphraseConstraints.fromDataItem(Cbor.decode(data))
}

val PassphraseConstraints.Companion.cborSchemaId: ByteString
    get() = PassphraseConstraints_cborSchemaId

fun PassphraseConstraints.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("minLength", this.minLength.toLong().toDataItem())
    builder.put("maxLength", this.maxLength.toLong().toDataItem())
    builder.put("requireNumerical", this.requireNumerical.toDataItem())
    return builder.end().build()
}

fun PassphraseConstraints.Companion.fromDataItem(dataItem: DataItem): PassphraseConstraints {
    val minLength = dataItem["minLength"].asNumber.toInt()
    val maxLength = dataItem["maxLength"].asNumber.toInt()
    val requireNumerical = dataItem["requireNumerical"].asBoolean
    return PassphraseConstraints(
        minLength = minLength,
        maxLength = maxLength,
        requireNumerical = requireNumerical,
    )
}
